export default __webpack_public_path__ + "static/media/icon_buy.e0283697.svg";